import React from 'react';
import PlanButton from './PlanButton';
import styles from '@dazn/lp-web/src/components/ContentTiers/ComparePlan/compare-plan.module.css';
import {IContentTierBillingPlans, TBillingPeriod} from '@dazn/lp-web/src/types';

interface PlanSelectorProps {
    setBillingPlan: (plan: TBillingPeriod) => void;
    billingPlanSwitch: TBillingPeriod;
    billingPlans?: IContentTierBillingPlans[];
    leftAligned?: boolean;
}

const PlanSelector: React.FC<PlanSelectorProps> = ({
    setBillingPlan,
    billingPlanSwitch,
    billingPlans
}) => {
    return (
        <div className={styles.comparePlanDiv}>
            <div className={styles.comparePlanContainer} id="lp_plan_selector">
                {billingPlans?.map((plan) => (
                    <PlanButton
                        key={plan.billingPeriodType}
                        label={plan.label}
                        value={plan.billingPeriodType}
                        badge={plan.showBadge}
                        tag={plan.badgeText || ''}
                        onClick={setBillingPlan}
                        className={`${styles.planButton} ${
                            billingPlanSwitch === plan.billingPeriodType &&
                            styles.planButtonBackground
                        }`}
                    />
                ))}
            </div>
        </div>
    );
};

export default PlanSelector;
